var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2309 22.64C20.5843 23.0644 21.2149 23.122 21.6393 22.7686C22.0637 22.4152 22.1213 21.7846 21.7679 21.3602L17.3046 16.0001L21.7684 10.64C22.1218 10.2156 22.0643 9.58505 21.6399 9.23163C21.2155 8.8782 20.585 8.93573 20.2315 9.36012L15.2349 15.3601C14.9261 15.7308 14.9261 16.2692 15.2348 16.6399L20.2309 22.64Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2312 22.64C13.5846 23.0644 14.2151 23.122 14.6395 22.7686C15.064 22.4152 15.1215 21.7846 14.7681 21.3602L10.3049 16.0001L14.7686 10.64C15.1221 10.2156 15.0645 9.58507 14.6401 9.23164C14.2157 8.87821 13.5852 8.93575 13.2318 9.36014L8.23511 15.3601C7.92636 15.7309 7.92635 16.2692 8.23507 16.6399L13.2312 22.64Z",
    fill: "currentColor"
  })));
};
export default SvgLeftArrow;